import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { FormComponent } from '../form';

import { MainComponent } from './main.component';

export const MainRoutes: Routes = [
    {
        path: 'evaluation', // TODO revise naming
        canActivate: [AuthService],
        children: [
            {
                path: '',
                component: MainComponent,
                children: [
                    {
                        path: 'drafts',
                        component: FormComponent,
                    },
                    {
                        path: 'drafts/:draftId',
                        component: FormComponent,
                    },
                ],
            },
        ],
    },
];
